export CreateRoute from './create';
export OnboardingRoute from './onboarding';
export GalleryRoute from './gallery';
export HeatMapRoute from './heat-map';


// WEBPACK FOOTER //
// ./src/routes/projects/index.js